export class BaseDisplaySet {
    constructor(options) {
        this.displaySetId = options.displaySetId;
        this.isDisplayable = options.isDisplayable ?? true;
        this.instances = [...(options.instances ?? [])];
        this.imageIds = [...(options.imageIds ?? [])];
        this.underlyingImageIds = [...(options.underlyingImageIds ?? [])];
    }
}
